var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1368_41950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 15.6112C11.6825 15.6112 14.6673 12.6264 14.6673 8.9445C14.6673 5.2626 11.6825 2.27783 8.00065 2.27783C4.31875 2.27783 1.33398 5.2626 1.33398 8.9445C1.33398 12.6264 4.31875 15.6112 8.00065 15.6112Z",
    stroke: "#4F4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 12.2775C9.8403 12.2775 11.3327 10.7851 11.3327 8.94417C11.3327 7.10322 9.8403 5.61084 7.99935 5.61084C6.1584 5.61084 4.66602 7.10322 4.66602 8.94417C4.66602 10.7851 6.1584 12.2775 7.99935 12.2775Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1368_41950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.944336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleOption);
export default __webpack_public_path__ + "static/media/multiple-option.b0257bebcb65db3056c9a71d302567be.svg";
export { ForwardRef as ReactComponent };